import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportContainerComponent } from './import-container';
import { ImportPresenterComponent } from './import-presenter';
import { UIRouterModule } from '@uirouter/angular';
import { ImportRoute } from './import.route';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [ImportContainerComponent, ImportPresenterComponent],
    imports: [
        CommonModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [ImportRoute]
        }),
        SharedModule
    ]
})
export class ImportModule {}
